<template>
  <div style="margin-bottom: 30px">
    <span><img class="lineimg" src="../../assets/img/left.png" /></span>
    <span style="margin:0 50px">{{titleparam.title}}</span>
    <span><img class="lineimg" src="../../assets/img/right.png" /></span>
    <!-- <router-link v-if="titleparam.morelink!=''&&titleparam.morelink" :to='titleparam.morelink' style="font-size: 15px;color: #8C8C8C;font-weight: 400;text-decoration: none;display: inline-block;">更多 >></router-link> -->
  </div>
</template>

<script>
export default {
  name: 'z-card',
  props: {
    titleparam: {
      type: Object,
      default () {
        return {
          title: '',
          morelink: ''
        }
      }
    }
  }
}
</script>

<style scoped>
 .lineimg{
  width: 169px;
  height: 12px;
 }
</style>



// WEBPACK FOOTER //
// src/components/card/index.vue